import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

import { parseWellCorrelationWidgetInternalState } from '../../../pages/dashboard/features/well-correlation-widget/parseWellCorrelationWidget';
import { WellCorrelationWidgetEntity } from '../../../pages/dashboard/features/well-correlation-widget/WellCorrelationWidget.entity';

export function mapWellCorrelationTemplate(
  template: TSerializedWidgetTemplate,
  index: number,
  options?: { wellId: number | null },
): WellCorrelationWidgetEntity {
  const { size, position } = template;

  const internalState = parseWellCorrelationWidgetInternalState(template.internalState ?? {});

  return new WellCorrelationWidgetEntity(
    {
      wellId: options?.wellId ?? null,
      stateParams: internalState.stateParams,
      type: 'well-correlation-widget',
    },
    {
      groupId: template.groupId || null,
      isGroupsDefaultOpened: false,
      uuid: template.uuid,
      isPinned: false,
      isFullscreen: false,
      zIndex: index + 1,
      size: {
        w: size.w,
        h: size.h,
      },
      position: {
        x: position.x,
        y: position.y,
      },
    },
  );
}
